import { render, staticRenderFns } from "./ServicesDirectory.vue?vue&type=template&id=2ebbf99e&scoped=true&lang=pug&"
import script from "./ServicesDirectory.vue?vue&type=script&lang=ts&"
export * from "./ServicesDirectory.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesDirectory.vue?vue&type=style&index=0&id=2ebbf99e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebbf99e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VImg,VLayout,VSpacer})
